import { CheckCircle, RoundedAddition } from 'ui/icons';
import Divider from 'ui/ds/Divider';
import { Button } from 'ui/mobile-ds';
import clsx from 'clsx';

interface IProps {
  showCount: boolean;
  relation: string;
  avatar: string;
  helperText: string;
  handleAddMemberFormOpen: (value: string) => void;
  isRelationCanBeAdded: boolean;
  allowedChildrenCount?: number;
  gender?: string;
  availableChildrenCount?: number;
}

const FamilyCard = ({
  showCount,
  relation,
  avatar,
  helperText,
  handleAddMemberFormOpen,
  allowedChildrenCount,
  availableChildrenCount,
  isRelationCanBeAdded,
}: IProps) => {
  return (
    <div
      className={clsx({
        'bg-white rounded-2xl py-4 px-5 border-secondary-200 border-[1px] cursor-pointer':
          true,
        '!bg-mobile-teal-10 border-none cursor-auto': !isRelationCanBeAdded,
      })}
      onClick={() => {
        if (isRelationCanBeAdded) handleAddMemberFormOpen(relation);
      }}
    >
      <div className="flex flex-row justify-between items-center">
        <div className="flex flex-row w-full">
          <img src={avatar} className="w-[42px] h-[42px]" />
          <div className="ml-2 w-full">
            <p className="text-lg font-semibold text-gray-600 mb-1 capitalize">
              {relation.toLocaleLowerCase()}
            </p>
            <p
              className={clsx({
                'text-sm md:text-base text-mobile-hero-100 w-[80%] md:w-fukk':
                  true,
                'text-teal-600': !isRelationCanBeAdded,
              })}
            >
              {helperText}
            </p>
          </div>
        </div>
        <div>
          {!isRelationCanBeAdded ? (
            <CheckCircle
              stroke="#41797A"
              fill="none"
              className="w-4 h-4 md:w-6 md:h-6"
              strokeWidth={2}
            />
          ) : (
            <Button className="min-w-0" intent="tertiary">
              <RoundedAddition className="w-4 h-4 md:w-6 md:h-6" />
            </Button>
          )}
        </div>
      </div>
      {showCount && (
        <>
          <div className="mt-6">
            <Divider className="border-dashed border-mobile-gray-200" />
          </div>
          <p className="mt-12 text-sm md:text-base text-gray-500">
            {allowedChildrenCount
              ? `${
                  allowedChildrenCount - (availableChildrenCount ?? 0)
                }/${allowedChildrenCount} Children Added`
              : 'Children count not available'}
          </p>
        </>
      )}
    </div>
  );
};

export default FamilyCard;
